import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { trackOffer } from '../data/offerAnalytics'

export function OfferAnalytics() {
  const route = useLocation()
  useEffect(() => {
    if (route.pathname.startsWith('/digital-marketing') || route.pathname === '/free-website') window.scrollTo({ top: 0, behavior: 'instant' })
    const click = (event: MouseEvent) => {
      const target = (event.target as Element)?.closest?.('a')
      if (!target) return
      const name = target.dataset.offerEvent || (target.href.startsWith('tel:') ? 'phone_click' : target.href.startsWith('mailto:') ? 'email_click' : '')
      if (name) trackOffer(name, target.dataset.plan)
    }
    document.addEventListener('click', click)
    return () => document.removeEventListener('click', click)
  }, [route.pathname, route.search])
  return null
}
